(function () {
  const container = document.querySelector('#sodataste-jobs');
  if (!container) return;

  const jobs = [];

  container.querySelectorAll('.multicolumn-card').forEach(card => {
    const titleEl = card.querySelector('h3');
    const rte = card.querySelector('.rte');
    if (!titleEl || !rte) return;

    const title = titleEl.textContent.trim();
    const rteClone = rte.cloneNode(true);
    rteClone.querySelectorAll('p a').forEach(a => a.remove());
    rteClone.querySelectorAll('em').forEach(em => em.remove());
    const description = rteClone.innerText.trim();

    const links = rte.querySelectorAll('p a[href$=".pdf"]');
    const pdfLink = links.length ? links[links.length - 1].href : null;

    let datePosted = null;
    const emEl = card.querySelector('em');
    if (emEl) {
      const match = emEl.textContent.match(/(\d{2})\.(\d{2})\.(\d{4})/);
      if (match) {
        datePosted = `${match[3]}-${match[2]}-${match[1]}`;
      }
    }

    const job = {
      "@context": "https://schema.org",
      "@type": "JobPosting",
      "title": title,
      "description": description,
      ...(datePosted && { "datePosted": datePosted }),
      "hiringOrganization": {
        "@type": "Organization",
        "name": "Sodataste",
        "sameAs": window.location.origin
      },
      "jobLocation": {
        "@type": "Place",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "",
          "extendedAddress": "",
          "postOfficeBoxNumber": "",
          "postalCode": "",
          "addressLocality": "Bremen",
          "addressRegion": "Bremen",
          "addressCountry": "DE"
        }
      }
    };

    if (pdfLink) {
      job.url = pdfLink;
    }

    jobs.push(job);
  });

  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.textContent = JSON.stringify(jobs, null, 2);
  document.head.appendChild(script);
})();